import { render, staticRenderFns } from "./ResponseStatusPage.vue?vue&type=template&id=0c05fd9c&scoped=true&"
import script from "./ResponseStatusPage.vue?vue&type=script&lang=js&"
export * from "./ResponseStatusPage.vue?vue&type=script&lang=js&"
import style0 from "./ResponseStatusPage.vue?vue&type=style&index=0&id=0c05fd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05fd9c",
  null
  
)

export default component.exports